import { Link } from 'react-router-dom';
import aboutHero from '../images/kerken/Kerk_1A.png';
// const janImg = require('../images/portretten/portretten_1A.png');
import janImg from '../images/portretten/portretten_1A.png';
// const mariaImg = require('../images/portretten/portretten_1B.png');
import mariaImg from '../images/portretten/portretten_1B.png';
// const peterImg = require('../images/relief/Relief_1A.png');
import peterImg from '../images/relief/Relief_1A.png';
import placeholderImg from '../images/logo_jm_simpel.png';

const stats = [
  { label: 'Jaren Ervaring', value: '10+' },
  { label: 'Gerealiseerde Projecten', value: '500+' },
  { label: 'Tevreden Klanten', value: '98%' },
  { label: 'Materialen', value: '5+' },
];

const team = [
  {
    name: 'Jan de Vries',
    role: 'Oprichter & Hoofdontwerper',
    image: janImg || placeholderImg,
    bio: 'Met meer dan 15 jaar ervaring in 3D-printen en architectuur, leidt Jan ons team van experts.',
  },
  {
    name: 'Maria Jansen',
    role: '3D Print Specialist',
    image: mariaImg || placeholderImg,
    bio: 'Maria is gespecialiseerd in het printen van complexe architecturale modellen met de hoogste precisie.',
  },
  {
    name: 'Peter Smit',
    role: 'Klantenservice',
    image: peterImg || placeholderImg,
    bio: 'Peter zorgt ervoor dat elke klant persoonlijke aandacht krijgt en tevreden is met het eindresultaat.',
  },
];

export default function About() {
  return (
    <div className="min-h-screen bg-gray-50" style={{ background: 'var(--color-bg)', color: 'var(--color-text)' }}>
      {/* Hero banner */}
      <div className="relative section bg-white flex flex-col md:flex-row items-center justify-between rounded-2xl shadow-lg mb-8 sm:mb-12 overflow-hidden" style={{ minHeight: 180 }}>
        <div className="flex-1 p-4 sm:p-8 md:p-16">
          <h1 className="text-2xl sm:text-5xl font-extrabold mb-2 sm:mb-4 text-accent1 drop-shadow-lg text-left">Over Prints by Jeroen</h1>
          <p className="text-base sm:text-xl text-accent2 font-medium mb-2 sm:mb-4 text-left" style={{ textShadow: '0 2px 8px #23242B55' }}>
            Persoonlijk, creatief en met passie voor 3D-design
          </p>
        </div>
        <div className="flex-1 h-full min-h-[120px] sm:min-h-[220px] flex items-center justify-center">
          <img src={aboutHero} alt="Prints by Jeroen" className="object-contain w-full h-auto max-h-[120px] sm:max-h-[320px]" style={{ borderRadius: '0 2rem 2rem 0', objectPosition: 'center' }} />
        </div>
      </div>
      {/* Main content */}
      <div className="container-custom max-w-full sm:max-w-2xl mx-auto card flex flex-col gap-6 sm:gap-8 p-4 sm:p-8">
        <div>
          <h2 className="text-2xl font-bold mb-4 text-accent1">Wie ben ik?</h2>
          <p className="mb-4 text-lg">
            Mijn naam is Jeroen en naast mijn werk als engineer ben ik met veel passie bezig met 3D-design en 3D-printen. Elk product op deze site is door mijzelf getekend en geprint in mijn eigen studio. Ik vind het geweldig om unieke, persoonlijke objecten te maken – van kerken tot portretten en skylines – en mensen blij te maken met een tastbaar resultaat.
          </p>
          <p className="mb-2 text-lg">
            Of je nu een eigen ontwerp wilt laten printen, een bijzonder cadeau zoekt, of een architectonisch model wilt laten maken: ik help je graag met een ontwerp op maat en een professionele 3D-print.
          </p>
        </div>
        <div className="border-t border-grey pt-8">
          <h2 className="text-2xl font-bold mb-4 text-accent2">Wat is 3D printen?</h2>
          <p className="mb-2 text-lg">
          Prints by Jeroen werkt met FDM 3D-printtechniek. FDM staat voor Fused Deposition Modeling: een techniek waarbij een kunststof draad (filament) – in mijn geval PLA – laagje voor laagje wordt gesmolten en neergelegd tot het gewenste object ontstaat. 
          </p>
          <p className="mb-2 text-lg">
            PLA (polylactic acid) is een milieuvriendelijk, biologisch afbreekbaar materiaal op basis van maïs of suikerriet. Het is ideaal voor gedetailleerde prints, stevig, en veilig voor gebruik binnenshuis. Met FDM-printen kun je snel en betaalbaar unieke vormen maken, perfect voor persoonlijke ontwerpen en kleine oplages.
          </p>
          <p className="mb-2 text-lg">
            Wil je meer weten over het proces of heb je een idee voor een eigen ontwerp? Neem gerust contact op!
          </p>
        </div>
      </div>
    </div>
  );
} 